import { IAppState } from './../../appState/app.state';
import { Store } from '@ngrx/store';
import { IChangePasswordService } from './services/changePassword.service.interface';
import { ChangePasswordModel } from './entities/changePasswordModel';
import { Router } from '@angular/router';
import { Component, OnInit, Inject } from '@angular/core';
import { Location } from '@angular/common';

import { ChangePasswordService } from './services/changePassword.service';
import { SessionModel } from '../../session/entities/sessionModel';
import { AppState } from '../../appState/appStateStore.module';
import { PasswordChangedModel } from './entities/passwordChangedModel';
import { AbstractSessionService } from '../../session/abstract-session.service';

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.css']
})
export class ChangepasswordComponent implements OnInit {
  model: ChangePasswordModel = new ChangePasswordModel();
  message: string;
  passwordChanged = false;
  reason: string = '';
  loading: boolean = false;
  hide = true;
  hide2 = true;

  constructor(private router: Router, @Inject('IChangePasswordService') private changePasswordService: IChangePasswordService,
              private store: Store<AppState>, private location: Location, private sessionService: AbstractSessionService) { }

  ngOnInit() {
    let session: SessionModel = null;
    this.store.take(1).subscribe(s => session = s.app.session);
    if (session && session.passwordNeedsChange) {
      this.reason = session.passwordNeedsChange.Reason;
    }
  }

  onSubmit() {
    this.loading = true;

    if (this.model.PwNew !== this.model.PwNewRepeat) {
      this.model.PwNewRepeat = '';
      this.message = 'Ihre Wiederholung des neuen Passwortes war nicht identisch mit der ersten Eingabe.';
      return false;
    }

    return this.changePasswordService.change(this.model)
      .then(result => {
        this.loading = false;
        this.ergebnisAuswerten(result);
      })
      .catch(err => {
        this.loading = false;
        this.model.PwNew = '';
        this.model.PwNewRepeat = '';
        this.message = err;
      });
  }

  ergebnisAuswerten(result: PasswordChangedModel) {
    if (result && result.changed) {
      let session: SessionModel = null;
      this.store.take(1).subscribe(s => session = s.app.session);
      session.passwordNeedsChange.PasswordNeedsChange = false;
      session.passwordNeedsChange.Reason = '';
      this.passwordChanged = true;
      this.message = 'Ihr Passwort wurde erfolgreich geändert.';
      this.sessionService.activateIdle();
    } else {
      this.model.PwNew = '';
      this.model.PwNewRepeat = '';
      this.message = 'Es ist ein Fehler aufgetreten.';
    }
  }

  clearMessage() {
    this.message = null;
    if (this.passwordChanged) {
      this.router.navigate(['/kvNummerSuche']);
    }
  }

  onNewPasswordChange(elementToFocus) {
    this.model.PwNewRepeat = '';
    elementToFocus.focus();
  }

  goBackToPrev() {
    this.location.back();
  }

}



// WEBPACK FOOTER //
// ./src/app/account/changepassword/changepassword.component.ts